import { render } from "./holiday-model.vue?vue&type=template&id=11b9ed81"
import script from "./holiday-model.vue?vue&type=script&lang=js"
export * from "./holiday-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__